import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Body, Button, styled } from '@teko/ds-desktop';
import { SizeEnum } from '@teko/types/ds';
import locationImg from '../../assets/images/location.es.js';
import { t } from '../../i18n.es.js';
import { SelectionOption } from '../SelectionOption/SelectionOption.es.js';
import { useDevice } from '../../contexts/DeviceContext.es.js';

const RegionPicker = (_a) => {
    var { value, onChange, onSubmit, title, options } = _a, rest = __rest(_a, ["value", "onChange", "onSubmit", "title", "options"]);
    const { isMobile } = useDevice();
    return (jsxs(Wrapper, Object.assign({}, rest, { children: [jsx("div", Object.assign({ style: { marginBottom: 12, textAlign: 'justify' } }, { children: typeof title === 'string' ? jsx(Body, Object.assign({ level: 1 }, { children: title }), void 0) : title }), void 0), jsx(ImgWrapper, { src: locationImg, alt: "choose location" }, void 0), options.map((el) => {
                return (jsx(StyledSelectionOption, Object.assign({ isActive: value === el.value, onClick: () => {
                        onChange(el.value);
                    }, iconActiveSize: SizeEnum.s }, { children: el.text }), el.value));
            }), jsx(Button, Object.assign({ variant: "primary", size: isMobile ? 's' : 'm', block: true, onClick: () => onSubmit(value) }, { children: t('Xác nhận') }), void 0)] }), void 0));
};
const Wrapper = styled.div `
  text-align: center;
`;
const ImgWrapper = styled.img `
  margin: 32px;
`;
const StyledSelectionOption = styled(SelectionOption) `
  margin-bottom: 4px;
`;

export { RegionPicker };
